export default "__VITE_ASSET__gkGNyHkb__"